import { Grid, Paper } from '@mantine/core';
import { GroupSettingsForm } from './Forms/GroupSettingsForm';
import { StaffList } from './StaffList';
import { GroupReportsForm } from './Forms/GroupReportsForm';

export const GroupSettingsGeneral = () => {
  return (
    <Grid gutter={'lg'}>
      <Grid.Col span={6}>
        <Paper radius={'md'} p={'md'} withBorder>
          <GroupSettingsForm />
        </Paper>
      </Grid.Col>
      <Grid.Col span={6}>
        <Paper radius={'md'} p={'md'} withBorder>
          <GroupReportsForm />
        </Paper>
      </Grid.Col>
      <Grid.Col span={12}>
        <StaffList />
      </Grid.Col>
    </Grid>
  );
};
